export function checkSettings(data) {
    const emptyFields = [];
    let allFieldsFilled = false;
  
    for (const key in data) {
      if (["allowances_debit_account", "payslip_text", "logo", 'organisation_admin_email'].includes(key)) {
        delete data[key];
      }
  
      if (data.hasOwnProperty(key)) {
        if (data[key] === "") {
          emptyFields.push(key);
        }
      }
    }
  
    if (emptyFields.length === 0) {
      allFieldsFilled = true;
    }
  
    return {
      allFieldsFilled: allFieldsFilled,
      emptyFields: emptyFields,
    };
  }
  
